import { StyledTypography } from './style';

import type { ElementType, FC, HTMLAttributes } from 'react';

export type TypographyProps = HTMLAttributes<HTMLHeadingElement> & {
  type?: keyof typeof StyledTypography;
  as?: ElementType;
  href?: string;
};

export const Typography: FC<TypographyProps> = ({ type = 'B1', ...props }) => {
  const Component = StyledTypography[type];

  return <Component {...props} />;
};

// eslint-disable-next-line import/no-default-export
export default Typography;
